import React from 'react';
import FAQItem from '../common/FAQItem';
import { FAQ_DATA, WEBSITE_NAME } from '../../utils/constants';

const FAQSection = () => {
  return (
    <section id="faq" className="py-8 sm:py-12 md:py-16 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 sm:mb-10 md:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-2 sm:px-0">
            Get answers to common questions about selling on Amazon, Walmart, and TikTok Shop with {WEBSITE_NAME}.
          </p>
        </div>

        <div className="max-w-3xl mx-auto px-2 sm:px-0">
          {FAQ_DATA.map((faq, index) => (
            <FAQItem 
              key={index} 
              question={faq.question} 
              answer={faq.answer} 
            />
          ))}
        </div>

        {/* Additional Help */}
        <div className="text-center mt-8 sm:mt-10 md:mt-12 px-2 sm:px-0">
          <p className="text-gray-700 mb-3 sm:mb-4 text-sm sm:text-base">
            Still have questions?
          </p>
          <button className="bg-blue-600 text-white px-6 py-2.5 sm:px-8 sm:py-3 rounded-lg font-semibold hover:bg-blue-700 text-sm sm:text-base w-full sm:w-auto">
            Contact Support
          </button>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;